module.exports = __webpack_public_path__ + "img/covid-table-01.9c1a8774.png";